const doc = [({"da":({"js":({"admin":({"sheet_layouts":({"show":({"remove_box_icon":({"the_box_was_removed":"Boksen blev fjernet."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;